import React from 'react';

import classes from './MTableRow.module.scss';
import { RowData } from '../Table.model';
import { Cell, Row, TableInstance } from 'react-table';
import classNames from 'classnames';

type Props<T extends RowData> = {
  rowSelected: boolean;
  rowRef: React.MutableRefObject<null>;
  row: Row<T>;
  rowClasses?: (string | undefined)[];
  id: string;
  hiddenColumns: string[];
  hideSelection?: boolean;
  table: TableInstance<T>;
  columnCenter?: boolean;
  isDragging: boolean;
  renderExpand?: (row: Row<T>) => React.ReactElement | null;
  onRowClick?: (row: Row<T>) => void;
};

const MTableRowView = <T extends RowData>(props: React.PropsWithChildren<Props<T>>): JSX.Element => {
  return (
    <React.Fragment key={props.id}>
      <tr
        ref={props.rowRef}
        style={{ opacity: props.isDragging ? 0.5 : 1, border: props.isDragging ? 'dashed .5px #dadada' : 'none' }}
        className={props.rowClasses && props.rowClasses.join(' ')}
        {...props.row.getRowProps()}
        onClick={() => props.onRowClick?.(props.row)}
      >
        {props.row.cells
          .filter((cell: Cell<T>) => !props.hiddenColumns.includes(cell.column.id))
          .map((cell: Cell<T>, index: number, source: Cell<T>[]) => {
            const { key, ...rest } = cell.getCellProps();

            const cellClasses = [classes['cell']];

            if (props.rowSelected) {
              cellClasses.push(classes['cell--selectedRow']);
            }

            return (
              <td
                className={`${cellClasses.join(' ')} ${index === 0 && !props.hideSelection ? classes['cell--checked'] : ''}`}
                key={key}
                {...rest}
              >
                <div
                  className={`${classes['content']} ${
                    (index === 0 && props.hideSelection) || (index === 1 && !props.hideSelection) ? classes['content--titleLast'] : ''
                  } ${index === 0 && props.hideSelection ? classes['content--noSelectionTitleLast'] : ''} ${
                    index === source.length - 1 ? classes['content--last'] : ''
                  }`.trim()}
                >
                  <div className={classNames(classes['contentData'], { [classes['contentData--center']]: props.columnCenter })}>
                    {cell.render('Cell', cell.column.id === 'selection' ? { className: classes['contentCell'] } : {})}
                  </div>
                </div>
              </td>
            );
          })}
      </tr>
      {props.row.isExpanded ? (
        <tr className={classes['expandedRow']}>
          <td colSpan={props.table.visibleColumns.length}>{props.renderExpand?.(props.row) || null}</td>
        </tr>
      ) : null}
    </React.Fragment>
  );
};

MTableRowView.displayName = 'MTableRowView';
MTableRowView.defaultProps = {};

export default MTableRowView;
